import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function BottomBar() {
  const [items, setItems] = useState([]);
  const makeHref = (item) => item.url || `/content/${item.code}`;
  const isActive = (target) => path === target ? "active-link" : "";

  useEffect(() => {
    fetch(`${API}/api/menu-items/bottom-menu`)
      .then(r => r.json())
      .then(setItems)
      .catch(() => { });
  }, []);

  if (items.length === 0) return null;

  return (
    <footer className="bottombar">
      {items.map(item => {
        const isHome = item.url === "/";
        let href = isHome ? "/" : (item.url === "/aanmelden" && currentAthlete ? "/onboarding" : makeHref(item));
        let title = (item.url === "/aanmelden" && currentAthlete) ? "Mijn profiel" : (item.menuTitle || item.title);

        return (
          <a key={`mobile-bottom-${item.code}`} href={href} className="mobile-menu-secondary">
            {title}
          </a>
        );
      })}
    </footer>
  );
}
